import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

// This entity holds  the change in the break times for a unit on a specific occasionsal date if any
@Entity('m_unit_day_break')
export class UnitDayBreakEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 5,
        name: 'unit_id'
    })
    unitId: string;

    @Column('date', {
        nullable: false,
        name: 'date'
    })
    date: string;
    // The effected date on which the default plant break times are being changed

    @Column('varchar', {
        nullable: false,
        length: '5',
        name: 'break_time_from'
    })
    breakTimeFrom: string;
    // the break begin time in the 00:00 format

    @Column('varchar', {
        nullable: false,
        length: '5',
        name: 'break_time_to'
    })
    breakTimeTo: string;
    // the break end time in the 00:00 format

    @Column('tinyint', {
        nullable: false,
        name: 'break_minutes'
    })
    breakMinutes: string;
    // the break end time in the 00:00 format

    @Column('varchar', {
        nullable: false,
        length: '30',
        name: 'break_desc'
    })
    breakDesc: string;

    @Column('boolean', {
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}